import moment from 'moment';
import {useState} from 'react';
import {DateRangePicker as ReactDatesRange} from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import './SelectADate.scss';

const handleDateChange = ({setStartDate, setEndDate, onChange}) => dateObj => {
  setStartDate(dateObj.startDate);
  setEndDate(dateObj.endDate);
  const dateRange = {
    start: dateObj.startDate ? dateObj.startDate.format('MM/DD/yyyy') : null,
    end: dateObj.endDate ? dateObj.endDate.format('MM/DD/yyyy') : null,
  };
  onChange({target: {value: dateRange}});
};

const DateRangePicker = props => {
  const [state, setState] = useState({focusedInput: null});
  const [startDate, setStartDate] = useState(
    props.defaultValue && props.defaultValue.start
    ? moment(props.defaultValue.start)
    : null
  );
  const [endDate, setEndDate] = useState(
    props.defaultValue && props.defaultValue.end
    ? moment(props.defaultValue.end)
    : null
  );
  return (
    <ReactDatesRange
      startDate={props.startDate || startDate}
      startDateId='DateRangePickerStartDateId'
      endDate={props.endDate || endDate}
      endDateId='DateRangePickerEndDateId'
      onDatesChange={handleDateChange({
        setStartDate,
        setEndDate,
        onChange: props.onChange
      })}
      focusedInput={state.focusedInput}
      onFocusChange={focusedInput => setState({focusedInput})}
    />
  );
};

export default DateRangePicker;
